import { render } from "./CustomSelectOneCoveringType.vue?vue&type=template&id=482698ac"
import script from "./CustomSelectOneCoveringType.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneCoveringType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__